import PropTypes from 'prop-types';

import * as PostTypes from 'hb-react/frontoffice/apps/LiveFeed/constants/PostTypes';
import { useLiveFeedContext } from 'hb-react/frontoffice/apps/LiveFeed/contexts/LiveFeedContext';
import CheckInFormModal from 'hb-react/frontoffice/components/CheckInFormModal';
import TripFormModal from 'hb-react/frontoffice/components/TripFormModal';
import UserPostFormModal from 'hb-react/frontoffice/components/UserPostFormModal';

const EditItem = ({
  handleCloseEditModal,
  postType,
  isOpen,
  item,
  handleUpdateItem,
  topic,
}) => {
  const {
    config: { type: configType },
  } = useLiveFeedContext();

  if (postType === PostTypes.POST) {
    return (
      <UserPostFormModal
        isOpen={isOpen}
        onCloseModal={handleCloseEditModal}
        onUpdate={handleUpdateItem}
        topic={topic}
        type={configType}
        userPost={item}
        userPostId={item.id}
      />
    );
  }

  if (postType === PostTypes.CHECKIN) {
    return (
      <CheckInFormModal
        isOpen={isOpen}
        onUpdate={handleUpdateItem}
        onCloseModal={handleCloseEditModal}
        checkIn={item}
        checkInId={item.id}
      />
    );
  }

  if (postType === PostTypes.TRIP) {
    return (
      <TripFormModal
        isOpen={isOpen}
        onUpdate={handleUpdateItem}
        onCloseModal={handleCloseEditModal}
        trip={item}
        tripId={item.id}
      />
    );
  }

  return null;
};

EditItem.propTypes = {
  handleCloseEditModal: PropTypes.func.isRequired,
  handleUpdateItem: PropTypes.func.isRequired,
  postType: PropTypes.string.isRequired,
  isOpen: PropTypes.bool,
  item: PropTypes.object.isRequired,
};

export default EditItem;
